import Vue from "vue";
import VueRouter from "vue-router";
import GuardNav from '../views/GuardNav.vue'
import InnerNav from '../views/InnerNav.vue'
import GoodsNav from '../views/GoodsNav.vue'
import BottleNav from '../views/BottleNav.vue'
import CheckNav from '../views/CheckNav.vue'
import Regester from '../views/regester.vue'
import Sushe from '../views/Sushe.vue'
import AddCar from '../views/addCar.vue'
import Personal from '../views/personal.vue'
import Edit from '../views/edit.vue'
import comments from "@/views/room/comments.vue"
import plain from '../views/plain/index.vue'
import meetting from '../views/meeting/index.vue'
import meetingDetail from '../views/meeting/remark.vue'
import repaire from '../views/room/repaire.vue'
import auditing from '../views/auditing/index.vue'
import cars from '../views/cars/index.vue'
import AddRoom from '../views/room/addRoom.vue'
import audit from '../views/bottle/audit.vue'
import {
	getTokens,
	getCodes
} from '../apis/api'
import * as appId from '../../public/index.js'
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
const routes = [{
		path: "/",
		name: "Home",
		redirect: '/regester'
	},
	{
		path:'/guardnav',
		component: GuardNav
	},
	{
		path:'/checknav',
		component: CheckNav
	},
	{
		path: '/innernav',
		component: InnerNav
	},
	{
		path: '/googdsnav',
		component: GoodsNav
	},
	{
		path: '/bottlenav',
		component: BottleNav
	},
	{
		path: '/personal',
		component: Personal
	},
	{

		path: '/regester',
		component: Regester
	},
	{
		path: '/sushe',
		component: Sushe
	},
	{
		path: '/addCar',
		component: AddCar
	},
	{
		path: '/edit',
		component: Edit
	},
	{
		path: '/comments',
		component: comments
	},
	{
		path: '/plain',
		component: plain
	},
	 {
        path: '/meetting',
        component: meetting
    },
    {
        path: '/meetingDetail',
        component: meetingDetail
    }, {
        path: '/repaire',
        component: repaire
    },	
 	{
        path: '/auditing',
        component: auditing
    },
	{
        path: '/cars',
        component: cars
    },
	{
		path:'/addRoom',
		component:AddRoom
	},
	{
		path: '/appointment',
		component: () => import('@/views/visitor/appointment.vue')
	},
	{
		path: '/appHistory',
		component: () => import('@/views/visitor/app-history.vue')
	},
	{
		path: '/examine',
		component: () => import('@/views/visitor/examine.vue')
	},
	{
		path: '/vehicle_report',
		component: () => import('@/views/vehicle/report.vue')
	},
	{
		path: '/vehicle_review',
		component: () => import('@/views/vehicle/review.vue')
	},
	{
		path: '/vehicle_guard',
		component: () => import('@/views/vehicle/guard.vue')
	},
	{
		path: '/material_apply',
		component: () => import('@/views/material/apply.vue')
	},
	{
		path: '/material_examine',
		component: () => import('@/views/material/examine.vue')
	},
	{
		path: '/material_query',
		component: () => import('@/views/material/query.vue')
	},
	//气瓶审核
	{
		path: '/audit',
		component: () => import('@/views/bottle/audit.vue')
	},
	//气瓶入库
	{
		path: '/warehousing',
		component: () => import('@/views/bottle/warehousing.vue')
	},
	//气瓶领用
	{
		path: '/bottle_apply',
		component: () => import('@/views/bottle/apply.vue')
	},
	//气瓶归还
	{
		path: '/bottle_return',
		component: () => import('@/views/bottle/return.vue')
	},
	//气瓶汇总统计
	{
		path: '/stock',
		component: () => import('@/views/bottle/stock.vue')
	},
	//气瓶领用超期预警
	{
		path: '/warning',
		component: () => import('@/views/bottle/warning.vue')
	},
	//气瓶检测有效期预警
	{
		path: '/earlyWarn',
		component: () => import('@/views/bottle/earlyWarn.vue')
	},
	//气瓶出库
	{
		path: '/outbound',
		component: () => import('@/views/bottle/outbound.vue')
	}
];
const router = new VueRouter({
	mode: 'history', //去掉url中的#
	routes,
});

function getUrlParam(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}
router.beforeEach((to, from, next) => {
	let openId = localStorage.getItem('openId');
    let token = localStorage.getItem('token');
    let path = localStorage.getItem("path");
	console.info("openId="+openId+", token="+token+", path="+path)
	console.info("to="+to.name+", from="+from.name)
	let curTicket=(new Date()).getTime()
	let codeTicket=localStorage.getItem("code_ticket")
	if(codeTicket && curTicket-codeTicket>7000*1000)
	{
		console.info("code ticket超时，清空前端所有code token")
		localStorage.removeItem("code")
		localStorage.removeItem("code_ticket")
		localStorage.removeItem("token")
	}
    if (token ) {
        next()
    }else {
        const code = getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
        const local = window.location.href;
        if (!code) {          
            let redirectUri = encodeURIComponent(local);
            //let base_url="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04f1393fd9b230b8&redirect_uri=REDIRECT_URI&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
            let base_url =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId.appId +
                "&redirect_uri=REDIRECT_URI&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
            base_url = base_url.replace("REDIRECT_URI", redirectUri);
            console.log("base_url", base_url);
            window.location.href = base_url;
        } else {            

            getTokens({
                code
            }).then((res) => { //如果code存在获取信息

                localStorage.setItem("openId", res.result.openid);
                // localStorage.setItem('path', to.path)
                localStorage.setItem('code', code)
				localStorage.setItem('code_ticket',new Date().getTime())
				console.info("获取code成功，存储")
                if (res.result.token) {
                    localStorage.setItem("token", res.result.token);
					console.info("获取token成功，存储")
                    next()                      
                } else {
					console.info("没有获取到token,跳转注册页面")
                    //next("/regester")					
					next("/personal")
                }
            });
        }
        //next()
    }
	

})

export default router;
